module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"weeklyHeartTitle":"Fyll opp hjertet ditt med daglige brain dates"},"en":{"weeklyHeartTitle":"Fill up your heart with daily brain dates"}}')
  delete Component.options._Ctor
}
